/* EkDoTee: product card videos. Only one card video plays at a time.
   Mouse: plays only while the pointer is actually over a card. Scrolling under a still pointer does not start videos.
   Touch: plays only while a card is pressed. Never autoplays on scroll. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var current = null;
  var moved = false;      // true only after a real mouse movement
  var lastX = -1, lastY = -1;

  function wrapOf(v) { return v.closest('.card__media--video'); }
  function videoOf(target) {
    var card = target && target.closest && target.closest('.card');
    return card && card.querySelector('[data-card-video]');
  }
  function stop(v) {
    if (!v) return;
    v._want = false;
    var w = wrapOf(v); if (w) w.classList.remove('is-playing');
    try { v.pause(); v.currentTime = 0; } catch (e) {}
    if (current === v) current = null;
  }
  function stopAll(except) {
    document.querySelectorAll('[data-card-video]').forEach(function (v) { if (v !== except && (!v.paused || v._want)) stop(v); });
  }
  function play(v) {
    if (current && current !== v) stop(current);
    stopAll(v);
    current = v;
    v._want = true;
    if (!v.src && v.dataset.src) v.src = v.dataset.src;
    var w = wrapOf(v);
    var p = v.play();
    var show = function () { if (v._want && current === v && w) w.classList.add('is-playing'); else stop(v); };
    if (p && p.then) p.then(show).catch(function () {}); else show();
  }

  /* Mouse: hover only, and only after the mouse really moves */
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    if (e.clientX === lastX && e.clientY === lastY) return;
    lastX = e.clientX; lastY = e.clientY;
    moved = true;
    var v = videoOf(e.target);
    if (v) { if (current !== v) play(v); }
    else if (current) stop(current);
  });
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    if (!moved) return;
    var v = videoOf(e.target);
    if (v) { if (current !== v) play(v); }
    else if (current) stop(current);
  });
  document.addEventListener('mouseleave', function () { if (current) stop(current); });
  window.addEventListener('blur', function () { if (current) stop(current); });
  window.addEventListener('scroll', function () { moved = false; if (current) stop(current); }, { passive: true });

  /* Touch: plays only while a finger is on the card */
  document.addEventListener('touchstart', function (e) {
    var v = videoOf(e.target);
    if (v) play(v); else if (current) stop(current);
  }, { passive: true });
  ['touchend', 'touchcancel'].forEach(function (t) {
    document.addEventListener(t, function () { if (current) stop(current); }, { passive: true });
  });
  document.addEventListener('touchmove', function () { if (current) stop(current); }, { passive: true });

  document.addEventListener('visibilitychange', function () { if (document.hidden) stopAll(null); });
})();
